import { createSelector } from 'reselect'

const getCategoriesOptions: SelectOptionsSelector = state =>
  state.categories.categoriesForOptions.map(item => ({
    id: item.id,
    name: item.name
  })) || ([] as SelectOption[])

export const categoriesSelectOptionsSelector: SelectOptionsSelector = createSelector(getCategoriesOptions, options => options)
